<template>
  <div>
    <question-edit-info
      :is-edit-question-sidebar-active.sync="isEditQuestionSidebarActive"
      :question-data="viewQuestionData"
      @updateQuestionInfo="questionViewInfoUpdate"
    />
    <b-card>
      <b-row>
        <!-- User Info: Left col -->
        <b-col
          cols="21"
          xl="6"
          class="d-flex justify-content-between flex-column"
        >
          <!-- User Avatar & Action Buttons -->
          <div class="d-flex justify-content-start">
            <b-avatar
              :variant="`light-${resolveQuestionActiveVariant(viewQuestionData.active)}`"
              size="104px"
              rounded
            >
              <feather-icon
                :icon="resolveQuestionActiveIcon(viewQuestionData.active)"
                size="70"
              />
            </b-avatar>
            <div class="d-flex flex-column ml-1">
              <div class="mb-1">
                <h4 class="mb-0">
                  Walkaround Check
                </h4>
              </div>
              <div class="d-flex flex-wrap">
                <b-dropdown
                  id="dropdown-1"
                  variant="outline-primary"
                >
                  <template #button-content>
                    <b-spinner
                      v-if="isLoading"
                      small
                      class="mr-50"
                    />
                    <span>Actions</span>
                  </template>
                  <b-dropdown-item
                    @click="isEditQuestionSidebarActive = true"
                  >
                    <feather-icon
                      icon="Edit2Icon"
                      class="mr-50"
                    />
                    <span>Edit</span>
                  </b-dropdown-item>
                  <b-dropdown-item
                    :disabled="viewQuestionData.jobCount > 0"
                    variant="text-danger"
                    @click="deleteQuestion(viewQuestionData.id)"
                  >
                    <span class="text-danger">
                      <feather-icon
                        icon="Trash2Icon"
                        class="mr-50"
                      />
                      <span>Delete</span>
                    </span>
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </div>
          </div>
        </b-col>

        <!-- Right Col: Table -->
        <b-col
          cols="12"
          xl="6"
        >
          <table class="mt-2 mt-xl-0 w-100">
            <tr>
              <th class="pb-50">
                <feather-icon
                  icon="CheckIcon"
                  class="mr-75"
                />
                <span class="font-weight-bold">State</span>
              </th>
              <td class="pb-50 text-capitalize">
                {{ viewQuestionData.active ? 'Active' : 'Inactive' }}
              </td>
            </tr>


          </table>
        </b-col>
      </b-row>
      <b-row class="mt-2">
        <b-col>
          <b-card-text>

            <span class="font-weight-bold">Question</span>
            <div class="mt-2">
              {{ viewQuestionData.question }}
            </div>

            <b-row
              align-h="end"
              class="text-muted w-100 mt-2 mx-0"
            >
              <b-col
                class="text-right"
              >
                <feather-icon
                  icon="ClockIcon"
                  class="mr-75"
                />
                <span class="font-weight-bold">Added: {{ toHumanDate(viewQuestionData.createdAt) }}</span>
              </b-col>
            </b-row>
          </b-card-text>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BButton,
  BAvatar,
  BRow,
  BCol,
  BCardText,
  BSpinner,
  BDropdown,
  BDropdownItem,
  BModal,
  VBModal,
  BFormCheckbox,
} from 'bootstrap-vue'
import { avatarText } from '@core/utils/filter'
import toHumanDate from '@/libs/utils/general/dates'
import { ref, computed } from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import store from '@/store'
import useQuestionList from "@/views/question/useQuestionsList";
import questionEditInfo from '@/views/question/questions-edit/QuestionEditInfo.vue'

export default {
  directives: {
    Ripple,
    'b-modal': VBModal,
  },
  components: {
    BCard,
    BCardText,
    BRow,
    BCol,
    BAvatar,
    BSpinner,
    BDropdown,
    BDropdownItem,
    questionEditInfo,
  },
  props: {
    questionData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      viewQuestionData: this.$props.questionData,
      isLoading: false,
      inactiveQuestionCheckbox: false,
    }
  },
  methods: {
    deleteQuestion(id) {
      this.isLoading = true
      store.dispatch('app-question/deleteQuestion', id)
        .then(() => {
          this.$router.push({ name: 'questions-list' })
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Question deleted',
              icon: 'CheckSquareIcon',
              variant: 'success',
              text: 'You have successfully deleted this question.',
            },
          })
          this.isLoading = false
        })
        .catch(err => {
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Question update failed',
              icon: 'XIcon',
              variant: 'danger',
              text: err.response.data.message || 'An error occurred while deleting this question.',
            },
          })
          this.isLoading = false
        })
    },
    questionViewInfoUpdate(data) {
      this.viewQuestionData = data
    },
  },
  setup() {
    const { resolveQuestionActiveVariant, resolveQuestionActiveIcon } = useQuestionList()
    const isEditQuestionSidebarActive = ref(false)

    return {
      avatarText,
      resolveQuestionActiveVariant,
      toHumanDate,
      isEditQuestionSidebarActive,
      resolveQuestionActiveIcon,
    }
  },
}
</script>

<style>

</style>
